import React, { useCallback, useEffect, useState } from "react";
import Accordion from "../../../../components/Accordion";
import BrandItem from "../../../../components/brand";
import Spinner from "../../../../components/Loaders/Spinner";
import { useCategorizedEquipments } from "../../../../hooks/equipments/useCategorizedEquipments";
import useCommonStore from "../../../../stores/common";
import useOrganizationStore from "../../../../stores/organization";
import styles from "./styles.module.scss";
import { saveOrgEquipment } from "../../../../../api";
import toast from "react-hot-toast";

const BrandList = ({ brands, selectedEquipments, handleSaveOrgEquipments }) => {
  const handleAddEquipment = async (model, action) => {
    const newEquipments =
      action.type === "remove"
        ? (selectedEquipments || []).filter(
            (item) => item !== action.option.value,
          )
        : [...(selectedEquipments || []), action.option.value];

    await handleSaveOrgEquipments(newEquipments);
  };

  const handleRemoveAllEquipments = async (equipmentIds) => {
    const newEquipments = [...selectedEquipments].filter(
      (item) => !equipmentIds.includes(item),
    );

    await handleSaveOrgEquipments(newEquipments);
  };

  return (
    <div className={styles.equipmentsContainer}>
      {brands.map((brand) => (
        <BrandItem
          key={`brand-${brand.id}`}
          brand={brand}
          image={`/get-image-by-path?path=${brand.image}`}
          selectedEquipments={
            brand?.equipments?.filter((e) =>
              selectedEquipments?.includes(e.id),
            ) || []
          }
          handleAddEquipment={handleAddEquipment}
          handleRemoveAllEquipments={handleRemoveAllEquipments}
        />
      ))}
    </div>
  );
};

const Equipments = () => {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const { categorizedEquipments, loading, error } = useCategorizedEquipments();
  const [expandedItems, setExpandedItems] = useState(["mobile"]);
  const [saving, setSaving] = useState(false);
  const setSelectedOrganizationData = useOrganizationStore(
    (state) => state.setSelectedOrganizationData,
  );
  const selectedOrganizationId = useOrganizationStore(
    (state) => state.selectedOrganizationData?.organization?.id,
  );
  // Referencing data directly is the correct approach so as to re-render
  // on state changes from store
  const selectedEquipments = useOrganizationStore(
    (state) => state.selectedOrganizationData?.organization?.equipments,
  );

  const handleSaveOrgEquipments = useCallback(
    async (equipments) => {
      setSaving(true);
      toast.loading("Saving changes...");

      try {
        const response = await saveOrgEquipment({
          equipments: equipments.map((e) => ({ value: e })),
          organization_id: selectedOrganizationId,
        });

        toast.dismiss();

        if (!response?.status) {
          toast.error("Error saving equipments");
          return;
        }

        toast.success("Equipments saved successfully");
        setSelectedOrganizationData((prev) => {
          return {
            ...prev,
            organization: {
              ...prev.organization,
              equipments: [...equipments],
            },
          };
        });
      } catch (error) {
        toast.error("Error saving equipments");
      } finally {
        setSaving(false);
      }
    },
    [selectedOrganizationId, setSelectedOrganizationData],
  );

  const handleItemToggle = (id) => {
    if (expandedItems.includes(id)) {
      setExpandedItems(expandedItems.filter((item) => item !== id));
    } else {
      setExpandedItems([...expandedItems, id]);
    }
  };

  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "32px" }}
      >
        <Spinner />
      </div>
    );
  }

  const accordionItems = categorizedEquipments.map((category) => ({
    id: category.id,
    title: category.name,
    subtitle: `${category.brands.length} available`,
    content: (
      <BrandList
        brands={category.brands}
        selectedEquipments={selectedEquipments}
        handleSaveOrgEquipments={handleSaveOrgEquipments}
      />
    ),
  }));

  return (
    <div
      className={`${styles.webhook} ${expandDetails ? styles.expanded : ""}`}
    >
      <div className={`${styles.equipmentList}`}>
        <Accordion
          items={accordionItems}
          expandedItems={expandedItems}
          onItemToggle={handleItemToggle}
          className={styles.webhookAccordion}
        />
      </div>
    </div>
  );
};

export default Equipments;
